import inspectionWorkOrder from './inspectionWorkOrder';
import approveInspection from './approveInspection';
import workInspection from './workInspection';

export default {
	inspectionWorkOrderPage: inspectionWorkOrder,
	approveInspectionPage: approveInspection,
	workInspectionPage: workInspection
}